import { useCheckDevice, useToggleValue } from '@/hooks';
import { Button, Layout } from 'antd';
import React from 'react';
import { Breadcrumbs } from '../Common';

import { LogoImg, LogoutHelpCenterIcon } from '@/assets';
import HeaderMobile from '@/components/Layout/HeaderMobile';
import { UserLogout } from '@/store/auth/actions';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Sidebars } from './Sidebar';

interface IPropsLayoutMain {
  children: React.ReactNode;
}

export const LayoutMain: React.FC<IPropsLayoutMain> = ({ children }) => {
  const { Content } = Layout;
  const { isMobile } = useCheckDevice();
  const collapseStorage = isMobile ? 'false' : window.localStorage.getItem('collapse-menu') ?? 'false';
  const [collapsed, setCollapsed] = useToggleValue(JSON.parse(collapseStorage));
  return (
    <Layout>
      <Sidebars collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout>
        <div className="titan-header">
          <HeaderMobile />
          <Breadcrumbs />
        </div>
        <Content className="titan-layout__content">{children}</Content>
      </Layout>
    </Layout>
  );
};

export const LayoutWithoutSidebar: React.FC<IPropsLayoutMain> = ({ children }) => {
  const { Content } = Layout;
  const dispatch = useDispatch();
  return (
    <Layout>
      <div className="titan-header__without-sidebar">
        <Link to="/help-center" className="logo" style={{ cursor: 'pointer' }}>
          <img src={LogoImg} alt="" width={72} height={20} />
        </Link>

        <Button
          className="btn--outline"
          icon={<LogoutHelpCenterIcon />}
          onClick={() => {
            dispatch(UserLogout());
          }}
        >
          Log out
        </Button>
      </div>
      <Layout>
        <Content className="titan-layout__content">{children}</Content>
      </Layout>
    </Layout>
  );
};
